import { calculateAging, formatDate, formatTimeWithZoneAbbreviation } from ".";
import { MyQueryData } from "../components/Tables/MyQueryTable";
import { PatientQueryData } from "../components/Tables/PatientQueryTable";
import { DATE_FORMAT, querySubmittedStates } from "../constants/app-constant";

export const transformApiDataToPatientQuery = (
  apiData: any,
  statusOptions?: Array<{ value: string; label: string }>,
  timezone_info?: any
): PatientQueryData[] => {
  console.log("Raw API Data Structure:", apiData);
  console.log(statusOptions, "statusOptions");

  let dataArray: any[] = [];

  if (apiData?.data && Array?.isArray(apiData.data)) {
    dataArray = apiData.data;
  } else if (Array?.isArray(apiData)) {
    dataArray = apiData;
  } else {
    console.log("Unknown API data structure");
    return [];
  }

  console.log(`Processing ${dataArray.length} records from API`);

  // Helper function to get status label by ID
  const getStatusLabel = (statusId: string | null): string => {
    if (!statusId) return "NA"; // Default status when statusId is null

    const statusOption = statusOptions?.find(
      (option) => option.value === statusId
    );
    return statusOption ? statusOption.label : "Unknown Status";
  };

  // Transform each item to match PatientQueryData interface
  return dataArray?.map((item: any) => {
    const aging = calculateAging(item?.CREATED_DATE);
    const formattedDate = formatDate(
      item?.CREATED_DATE,
      DATE_FORMAT.MM_DD_YYYY
    );
    const formattedUpdatedDate = formatDate(
      item?.UPDATED_DATE,
      DATE_FORMAT.MM_DD_YYYY
    );
    const statusLabel = getStatusLabel(item.QUERY_STATUS_ID);
    const createdFormatTime = formatTimeWithZoneAbbreviation(
      item?.CREATED_DATE,
      timezone_info?.timezone_name,
      timezone_info?.abbrev_simple
    );
    const updatedFormatTime = formatTimeWithZoneAbbreviation(
      item?.UPDATED_DATE,
      timezone_info?.timezone_name,
      timezone_info?.abbrev_simple
    );
    //     const statusLower = statusLabel?.toLowerCase();
    // const hideAging = [
    //   "completed",
    //   "query agreed",
    //   "query disagreed",
    //   "unable to determine",
    //   "other",
    // ].includes(statusLower);
    const hideAging = querySubmittedStates.includes(item?.QUERY_STATUS_ID); ////STATUS CHANGES

    return {
      id: item?.QUERY_ID,
      topic: item?.TOPIC || "No Topic",
      status: statusLabel,
      statusId: item?.QUERY_STATUS_ID, ///STATUS CHANGES
      ageing: hideAging ? "-" : aging,
      queryBy: item?.CREATED_BY,
      queryDate: formattedDate,
      queryUpdatedDate: formattedUpdatedDate,
      patientId: item?.PATIENT_ID,
      isEditable: item?.IS_EDITABLE,
      createdFormatTime,
      updatedFormatTime,
    };
  });
};

export const transformApiDataToMyQueries = (
  apiData: any,
  statusOptions?: Array<{ value: string; label: string }>,
  timezone_info?: any
): MyQueryData[] => {
  console.log("Raw API Data Structure:", apiData);
  console.log(statusOptions, "statusOptions");

  let dataArray: any[] = [];

  if (apiData?.data && Array?.isArray(apiData.data)) {
    dataArray = apiData?.data;
  } else if (Array?.isArray(apiData)) {
    dataArray = apiData;
  } else {
    console.log("Unknown API data structure");
    return [];
  }

  console.log(`Processing ${dataArray.length} records from API`);

  // Helper function to get status label by ID
  const getStatusLabel = (statusId: string | null): string => {
    if (!statusId) return "NA"; // Default status when statusId is null

    const statusOption = statusOptions?.find(
      (option) => option?.value === statusId
    );
    return statusOption ? statusOption?.label : "Unknown Status";
  };

  // Transform each item to match MyQueryData interface
  return dataArray?.map((item: any) => {
    const aging = calculateAging(item?.CREATED_DATE);
    const formattedDate = formatDate(
      item?.CREATED_DATE,
      DATE_FORMAT.MM_DD_YYYY
    );
    const formattedUpdatedDate = formatDate(
      item?.UPDATED_DATE,
      DATE_FORMAT.MM_DD_YYYY
    );
    const statusLabel = getStatusLabel(item?.QUERY_STATUS_ID);
    const createdFormatTime = formatTimeWithZoneAbbreviation(
      item?.CREATED_DATE,
      timezone_info?.timezone_name,
      timezone_info?.abbrev_simple
    );
    const updatedFormatTime = formatTimeWithZoneAbbreviation(
      item?.UPDATED_DATE,
      timezone_info?.timezone_name,
      timezone_info?.abbrev_simple
    );
    const hideAging = querySubmittedStates.includes(item?.QUERY_STATUS_ID);

    return {
      id: item?.QUERY_ID,
      patientName: item?.PATIENT_NAME,
      patientMRN: item?.MRN_NO,
      topic: item?.TOPIC || "No Topic",
      status: statusLabel, // Now dynamically mapped from statusOptions
      statusId: item?.QUERY_STATUS_ID, ///STATUS CHANGES
      ageing: hideAging ? "-" : aging,
      queryBy: item?.CREATED_BY,
      queryDate: formattedDate,
      queryUpdatedDate: formattedUpdatedDate,
      patientId: item?.PATIENT_ID,
      isEditable: item?.IS_EDITABLE,
      createdFormatTime,
      updatedFormatTime,
    };
  });
};
